import { mapBaseAudioFile, mapBaseAudio } from './BaseAudio.mappers';
export const mapSecureAudio = (audio, file) => {
  const baseAudioOutput = mapBaseAudio(audio, file);
  const urlRegex = /preview\/.*\.mp3$/;
  const url = audio.url || '';
  const match = url.match(urlRegex);
  return {
    ...baseAudioOutput,
    url: match ? match[0] : undefined,
    quality: audio.quality || undefined
  };
};
const mapAudioFileOutput = file => {
  var _file$media;
  const assets = ((_file$media = file.media) == null || (_file$media = _file$media.audio) == null ? void 0 : _file$media.assets) || [];
  const audios = assets.map(asset => mapSecureAudio(asset, file));
  return {
    audio: audios
  };
};
export const mapSecureAudioFile = (file, baseFile) => {
  const baseAudioFileDescriptor = mapBaseAudioFile(file, baseFile);
  return {
    mediaType: 'secure_music',
    fileOutput: mapAudioFileOutput(file),
    ...baseAudioFileDescriptor
  };
};
//# sourceMappingURL=SecureAudio.mappers.js.map